const BASE_URL = 'https://api.clxinternal.com';
// const BASE_URL = "http://localhost:3011";
const API_BASE_URL = `${BASE_URL}/api/`;

module.exports = {
    API_BASE_URL,
    BASE_URL
};
